import React from 'react';
import { SvgIconType } from 'common/components/svg-icon';
import { ButtonReact } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import styles from './_section.module.styl';
type ExperimentPageConfigurationSectionProps = {
  label: string;
  btnIcon?: SvgIconType;
  onButtonClick?: () => void;
  children: React.ReactNode;
};
export function ExperimentPageConfigurationSection(props: ExperimentPageConfigurationSectionProps) {
  return <div className={styles.section} data-sentry-component="ExperimentPageConfigurationSection" data-sentry-source-file="_section.tsx">
      <div className={styles.label}>
        <span>{props.label}</span>
        {props.btnIcon && <ButtonReact className={styles.btn} icon={props.btnIcon} onClick={props.onButtonClick} theme={ButtonTheme.Tertiary} size={ButtonSize.Inline} />}
      </div>
      <div className={styles.content}>{props.children}</div>
    </div>;
}